import metadata from './request'
import api from './Url'
import { UserServiceClient } from '../pbs/user_grpc_web_pb'
import { Empty } from '../pbs/common_pb'
import {LoginUser,UserLogoutReq} from "../pbs/user_pb"

const service = new UserServiceClient(api,null,null)

/**
 * 获取图像验证码
 */
export function getVerCode() {
  return new Promise((resolve, reject) => {
    service.getCode(new Empty(), metadata(), (err, response) => {
      if (!err) { // 获取成功
        resolve([response.getCode(),response.getId()])
      } else { // 请求失败
        reject(err.message)
      }
    })
  })
}
/**
 * 登录方法
 */
export function login(username, passwd, code,metadata) {
  const request = new LoginUser()
  request.setUserName(username)
  request.setPassword(passwd)
  request.setCode(code)
  return new Promise((resolve, reject) => {
    //  调用客户端相应的grpc方法，发送grpc请求，并接受后台发送回来的返回值
    service.adminLogin(request, metadata, (err, response) => {
      if (!err) {
        console.log(response)
        resolve(response.toObject())
      } else {
        reject(err)
      }
    })
  })
}
/**
 * 获取用户信息
 */
export function homeuser() {
  return new Promise((resolve, reject) => {
    //  调用客户端相应的grpc方法，发送grpc请求，并接受后台发送回来的返回值
    service.getMyAccontInfo(new Empty(), metadata(), (err, response) => {
      if (!err) {
        console.log(response.toObject())
        resolve(response.toObject())
      } else {
        reject(err)
      }
    })
  })
}



// WEBPACK FOOTER //
// ./src/utils/login.js